import { Outlet } from "react-router-dom";
import "../styles-public.css";
import "../styles-public-redesign.css";

/** Loads legacy public CSS only for archived `/old1/*` routes. */
export default function Old1ArchiveLayout() {
  return <Outlet />;
}
